var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "student-side-menu"
  }, [_c('div', {
    staticClass: "user-info"
  }, [_c('a-avatar', {
    staticStyle: {
      "backgroundcolor": "#87d068"
    },
    attrs: {
      "shape": "square",
      "icon": "user",
      "src": _vm.avatarUrl
    }
  }), _c('h3', [_vm._v(_vm._s(_vm.userInfo.realname))])], 1), _c('a-divider', {
    staticStyle: {
      "width": "80%"
    }
  }), _c('div', [_c('a-menu', {
    attrs: {
      "mode": "inline"
    },
    on: {
      "click": _vm.handleClick
    },
    model: {
      value: _vm.selectedKeys,
      callback: function callback($$v) {
        _vm.selectedKeys = $$v;
      },
      expression: "selectedKeys"
    }
  }, [_c('a-menu-item', {
    key: "event"
  }, [_c('router-link', {
    attrs: {
      "to": "event"
    }
  }, [_c('a-icon', {
    attrs: {
      "type": "fire"
    }
  }), _vm._v("我的活动")], 1)], 1), _c('a-menu-item', {
    key: "cert"
  }, [_c('router-link', {
    attrs: {
      "to": "cert"
    }
  }, [_c('a-icon', {
    attrs: {
      "type": "solution"
    }
  }), _vm._v("我的证书")], 1)], 1), _c('a-menu-item', {
    key: "info"
  }, [_c('router-link', {
    attrs: {
      "to": "info"
    }
  }, [_c('a-icon', {
    attrs: {
      "type": "contacts"
    }
  }), _vm._v("个人信息")], 1)], 1), _c('a-menu-item', {
    key: "setting"
  }, [_c('router-link', {
    attrs: {
      "to": "setting"
    }
  }, [_c('a-icon', {
    attrs: {
      "type": "setting"
    }
  }), _vm._v("安全设置")], 1)], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };